<template>
    <zoezi-autocomplete
        v-model="icon"
        :label="label"
        :items="icons"
        @input="setValue"
        item-text="id"
        item-value="id"
        :clearable="clearable"
        color="zoezi-edit-color"
        :hint="hint"
    >
        <template v-slot:selection="{item}">
            <v-icon left>{{item}}</v-icon>{{item.substring(4)}}
        </template>
        <template v-slot:item="{item}">
            <v-icon left>{{item}}</v-icon>{{item.substring(4)}}
        </template>
    </zoezi-autocomplete>
</template>

<script>
import ZoeziAutocomplete from './ui/form/Autocomplete.vue';

export default {
    name: 'IconSetting',

    components: {
        ZoeziAutocomplete
    },

    props: {
        value: {},
        label: {},
        clearable: {
            type: Boolean,
            default: true
        },
        hint: {}
    },
    data: () => ({
        icon: null,
        icons: []
    }),
    methods: {
        setIcons() {
            // The icon browsing code crashes on mobile phones for some reason
            if (this.$vuetify.breakpoint.mobile) {
                return;
            }
            for (let i=0; i < document.styleSheets.length; ++i) {
                try {
                    let ss = document.styleSheets[i];
                    if (ss.rules.length > 3000) {
                        for (let r=0; r < ss.rules.length; ++r) {
                            let rule = ss.rules[r];
                            let match = rule.selectorText && rule.selectorText.match('.mdi-(.*)::before');
                            if (match) {
                                this.icons.push('mdi-' + match[1]);
                            }
                        }
                    }
                }
                catch {
                    // Empty
                }
            }
        },
        setValue() {
            this.$emit('input', this.icon);
        }
    },
    created() {
        this.icon = this.value;
    },
    mounted() {
        this.setIcons();
    }
}
</script>
